let eventExec = { value: false };

function getCheckoutButton() {
    return document.querySelector('.btn.cart__checkout');
}

function enableCheckoutButton() {
    const checkoutButton = getCheckoutButton();
    if (checkoutButton) {
        checkoutButton.removeAttribute('disabled');
        checkoutButton.disabled = false;
    }
}

// Sticky footer
if (document.querySelector('#footer.sticky-footer')) {
    document.body.classList.add('sticky-footer')
    if (window.matchMedia('(min-width: 1200px)').matches) {
        setTimeout(() => {
            document.documentElement.style.paddingBottom = document.querySelector('#footer.sticky-footer').clientHeight + 'px'
        }, 2000)
    }
}

// Carousel - full-screen on desktop (images)
document.querySelectorAll('.carousel.full-screen .carousel-item img.carousel-item-img')
    .forEach((img) => {
        const announcementBarHeight = document.querySelector('#announcement-bar')?.clientHeight || 0
        const topbarHeight = document.querySelector('#topbar')?.clientHeight || 0
        const navbarHeight = document.querySelector('#navbar')?.clientHeight || 0
        img.style.height = window.innerHeight - announcementBarHeight - navbarHeight - topbarHeight + 'px'
    })

// Carousel - full-screen on desktop (videos)
document.querySelectorAll('.carousel.full-screen .carousel-item video')
    .forEach((video) => {
        const announcementBarHeight = document.querySelector('#announcement-bar')?.clientHeight || 0
        const topbarHeight = document.querySelector('#topbar')?.clientHeight || 0
        const navbarHeight = document.querySelector('#navbar')?.clientHeight || 0
        video.style.height = window.innerHeight - announcementBarHeight - topbarHeight - navbarHeight + 'px'
    })

// Featured Products - Init SplideJS slider
const initAllSplideFeaturedProducts = () => {
    document.querySelectorAll('.featured-products .splide')
        .forEach((el) => {
            if (el.classList.contains('init')) {
                return false
            }
            el.classList.add('init')
            new Splide(el, {
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: true,
                breakpoints: {
                    [576 - 1]: {
                        perPage: Number(el.dataset.breakpointXs)
                    },
                    [768 - 1]: {
                        perPage: Number(el.dataset.breakpointSm)
                    },
                    [992 - 1]: {
                        perPage: Number(el.dataset.breakpointMd)
                    },
                    [1200 - 1]: {
                        perPage: Number(el.dataset.breakpointLg)
                    },
                    [1400 - 1]: {
                        perPage: Number(el.dataset.breakpointXl)
                    }
                },
                perPage: Number(el.dataset.breakpointXxl)
            }).mount()
        })
}
initAllSplideFeaturedProducts()

// Fancy Image Slider - Init SplideJS slider
const initAllSplideFancyImageSlider = () => {
    document.querySelectorAll('.fancy-image-slider .splide')
        .forEach((el) => {
            if (el.classList.contains('init')) {
                return false
            }
            el.classList.add('init')
            new Splide(el, {
                type: 'loop',
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: true,
                breakpoints: {
                    [576 - 1]: {
                        perPage: Number(el.dataset.breakpointXs)
                    },
                    [768 - 1]: {
                        perPage: Number(el.dataset.breakpointSm)
                    },
                    [992 - 1]: {
                        perPage: Number(el.dataset.breakpointMd)
                    },
                    [1200 - 1]: {
                        perPage: Number(el.dataset.breakpointLg)
                    },
                    [1400 - 1]: {
                        perPage: Number(el.dataset.breakpointXl)
                    }
                },
                perPage: Number(el.dataset.breakpointXxl)
            }).mount()
        })
}
initAllSplideFancyImageSlider()

// Image overlay with slider - Init SplideJS slider
const initAllImageOverlayWithSlider = () => {
    document.querySelectorAll('.image-overlay-with-slider .splide')
        .forEach((el) => {
            if (el.classList.contains('init')) {
                return false
            }
            el.classList.add('init')
            const splide = new Splide(el, {
                type: 'slide',
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: false,
                breakpoints: {
                    [576 - 1]: {
                        perPage: Number(el.dataset.breakpointXs)
                    },
                    [768 - 1]: {
                        perPage: Number(el.dataset.breakpointSm)
                    },
                    [992 - 1]: {
                        perPage: Number(el.dataset.breakpointMd)
                    },
                    [1200 - 1]: {
                        perPage: Number(el.dataset.breakpointLg)
                    },
                    [1400 - 1]: {
                        perPage: Number(el.dataset.breakpointXl)
                    }
                },
                perPage: Number(el.dataset.breakpointXxl)
            })

            const updateArrows = () => {
                const prevArrow = el.querySelector('.splide__arrow--prev')
                const nextArrow = el.querySelector('.splide__arrow--next')

                prevArrow.innerHTML = splide.index
                nextArrow.innerHTML = splide.index + 2
            }

            splide.on('mounted', () => {
                updateArrows()
            })

            splide.on('moved', () => {
                updateArrows()
            })

            splide.mount()
        })
}
initAllImageOverlayWithSlider()

// Advanced Image Slider - Init SplideJS slider
const initAllAdvancedImageSlider = () => {
    document.querySelectorAll('.advanced-image-slider .splide')
        .forEach((el) => {
            if (el.classList.contains('init')) {
                return false
            }
            el.classList.add('init')
            const splide = new Splide(el, {
                type: 'slide',
                arrows: el.dataset.arrows === 'true',
                pagination: el.dataset.pagination === 'true',
                easing: el.dataset.easing,
                speed: Number(el.dataset.speed),
                autoplay: el.dataset.autoplay === 'true',
                interval: Number(el.dataset.interval),
                perMove: Number(el.dataset.perMove),
                rewind: false,
                breakpoints: {
                    [576 - 1]: {
                        perPage: Number(el.dataset.breakpointXs)
                    },
                    [768 - 1]: {
                        perPage: Number(el.dataset.breakpointSm)
                    },
                    [992 - 1]: {
                        perPage: Number(el.dataset.breakpointMd)
                    },
                    [1200 - 1]: {
                        perPage: Number(el.dataset.breakpointLg)
                    },
                    [1400 - 1]: {
                        perPage: Number(el.dataset.breakpointXl)
                    }
                },
                perPage: Number(el.dataset.breakpointXxl)
            })

            const fixPaginatin = () => {
                if (el.querySelector('.splide__pagination')) {
                    setTimeout(() => {
                        const items = splide.length
                        const perPage = splide.options.perPage

                        if (items <= perPage) {
                            el.querySelector('.splide__pagination').style.display = 'none'
                        } else {
                            el.querySelector('.splide__pagination').style.display = 'flex'
                        }
                    }, 250)
                }
            }

            splide.on('mounted', () => {
                fixPaginatin()
            })

            splide.on('updated', () => {
                fixPaginatin()
            })

            splide.mount()
        })
}
initAllAdvancedImageSlider()

// Featured Reviews - Init SplideJS slider
const initAllSplideFeaturedReviews = () => {
    document.querySelectorAll('.featured-reviews .splide')
        .forEach((splide) => {
            if (splide.classList.contains('init')) {
                return false
            }
            splide.classList.add('init')
            new Splide(splide, {
                type: 'loop',
                arrows: splide.dataset.arrows === 'true',
                pagination: splide.dataset.pagination === 'true',
                easing: splide.dataset.easing,
                speed: Number(splide.dataset.speed),
                autoplay: splide.dataset.autoplay === 'true',
                interval: Number(splide.dataset.interval),
                perMove: Number(splide.dataset.perMove),
                breakpoints: {
                    [576 - 1]: {
                        perPage: Number(splide.dataset.breakpointXs)
                    },
                    [768 - 1]: {
                        perPage: Number(splide.dataset.breakpointSm)
                    },
                    [992 - 1]: {
                        perPage: Number(splide.dataset.breakpointMd)
                    },
                    [1200 - 1]: {
                        perPage: Number(splide.dataset.breakpointLg)
                    },
                    [1400 - 1]: {
                        perPage: Number(splide.dataset.breakpointXl)
                    }
                },
                perPage: Number(splide.dataset.breakpointXxl)
            }).mount()
        })
}
initAllSplideFeaturedReviews()

// Instagram gallery
document.querySelector('#modal-instagram-gallery')?.addEventListener('show.bs.modal', (e) => {
    const {
        url,
        description,
        imgSrc,
        imgWidth,
        imgHeight,
        productUrl,
        productTitle,
        productImgSrc,
        productImgAlt,
        productCompareAtPrice,
        productPrice,
        productPriceVaries,
        textPostDetails,
        textViewPost,
        textOldPrice,
        textPriceFrom,
        textViewProduct
    } = e.relatedTarget.dataset
    const title = `${textPostDetails}`
    const body = `
        <div class="row">
            <div class="col-lg-8 mb-4 mb-lg-0">
                <img class="img-fluid w-100" src="${imgSrc}" alt="" width="${imgWidth}" height="${imgHeight}">
            </div>
            <div class="col-lg-4">
                <div class="card text-center mb-4 ${productTitle ? '' : 'd-none'}">
                    <a href="${productUrl}">
                        <img src="${window.resizeImage(productImgSrc || 'no-image.gif', '600x600', 'center')}" class="card-img-top" alt="${productImgAlt}">
                    </a>
                    <div class="card-body">
                        <h5 class="product-title h6 mb-1">
                            ${productTitle}
                        </h5>
                        <p class="product-price text-body mb-4">
                            <s class="product-price-compare text-muted me-1 ${productCompareAtPrice > productPrice ? '' : 'd-none'}">
                                <span class="visually-hidden">
                                    ${textOldPrice}
                                </span>
                                ${window.formatMoney(productCompareAtPrice)}
                            </s>
                            <span class="product-price-final">
                                <span class="price-from ${productPriceVaries === 'true' ? '' : 'd-none'}">
                                    ${textPriceFrom}
                                </span>
                                ${window.formatMoney(productPrice)}
                            </span>
                        </p>
                        <a href="${productUrl}" class="btn btn-primary btn-sm w-100">
                            ${textViewProduct}
                        </a>
                    </div>
                </div>
                <div class="rte mb-4">
                    ${description}
                </div>
                <a class="btn btn-outline-primary w-100 btn-sm" href="${url}" target="_blank">
                    ${textViewPost}
                </a>
            </div>
        </div>
    `
    e.target.querySelector('.modal-title').innerHTML = title
    e.target.querySelector('.modal-body').innerHTML = body
})

// Newsletter
if (window.location.href.indexOf('?customer_posted=true') > -1) {
    setTimeout(() => {
        document.querySelector('.newsletter').scrollIntoView()
    }, 750)
}

// Listen for changes in theme editor
document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.featured-products')) {
        initAllSplideFeaturedProducts()
    } else if (e.target.querySelector('.featured-reviews')) {
        initAllSplideFeaturedReviews()
    } else if (e.target.querySelector('.fancy-image-slider')) {
        initAllSplideFancyImageSlider()
    } else if (e.target.querySelector('.image-overlay-with-slider')) {
        initAllImageOverlayWithSlider()
    } else if (e.target.querySelector('.advanced-image-slider')) {
        initAllAdvancedImageSlider()
    }
})

// Animated Counters
const initAnimatedCounters = () => {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.querySelectorAll('.animated-counter').forEach(counter => {
                    const speed = Number(counter.dataset.speed)

                    const animate = () => {
                        const value = +counter.dataset.value
                        const data = +counter.innerText

                        const time = value / speed
                        if (data < value) {
                            counter.innerText = Math.ceil(data + time)
                            setTimeout(animate, 1)
                        } else {
                            counter.innerText = value
                        }
                    }
                    animate()
                })
            }
        })
    }, { threshold: 0.25 })

    document.querySelectorAll('.animated-counters').forEach((el) => {
        observer.observe(el)
    })
}
initAnimatedCounters()



document.addEventListener('DOMContentLoaded', function () {
    //Chrome Ios Browser Definitions
    var isChromeOnMac = /Chrome/.test(navigator.userAgent) && navigator.platform === 'MacIntel';

    if (isChromeOnMac) {
        document.body.classList.add('chromeIos');
    }
    //END - Chrome Ios Browser Definitions


    if (document.querySelectorAll('.page-type-product').length) {
        //Scrolling header height definitions

        var scrollHeaderHeight = 0;

        ['.shopify-section-group-header-group-new'].forEach(function (selector) {
            var element = document.querySelector(selector);
            if (element) {
                scrollHeaderHeight += element.offsetHeight;
            }
        });

        document.documentElement.style.setProperty('--scrollHeaderHeight', scrollHeaderHeight + 'px');
        //END - Scrolling header height definitions

        //Smooth scrolling of all links on the page except for .product-navbar
        function smoothScroll() {
            var allAnchorLinks = document.querySelectorAll('a[href^="#"]:not(.view-product)');

            allAnchorLinks.forEach(anchor => {
                anchor.addEventListener('click', function (e) {
                    e.preventDefault();

                    const targetId = this.getAttribute('href').substring(1);
                    const targetElement = document.getElementById(targetId);

                    if (targetElement) {
                        var headerHeight = 0;
                        ['#shopify-section-static-announcement-bar', '#shopify-section-static-announcement-bar-alt', '#shopify-section-global-top-bar-slider', '#shopify-section-global-timer-banner', '.shopify-section-group-header-group-new '].forEach(function (selector) {
                            var element = document.querySelector(selector);
                            if (element) {
                                headerHeight += element.offsetHeight;
                            }
                        });

                        var locationTop = targetElement.offsetTop - headerHeight;

                        window.scrollTo({
                            top: locationTop < 100 ? 0 : locationTop,
                            behavior: 'smooth'
                        });
                    }
                });
            });
        }
        smoothScroll();
        //END - smooth scrolling of all links on the page except for .product-navbar

        //Handling .product-navbar logic

        function setupScrollAndNavigation() {
            const navbarLinks = document.querySelectorAll('.product-navbar a');

            function onScroll() {
                const windowHeight = window.innerHeight;
                const scrollPosition = window.scrollY + windowHeight / 2;

                navbarLinks.forEach(function (link) {
                    const sectionId = link.getAttribute('href');
                    if (sectionId && sectionId.startsWith('#') && sectionId.length > 1) {
                        const section = document.querySelector(sectionId);
                        if (
                            section &&
                            scrollPosition >= section.offsetTop &&
                            scrollPosition < section.offsetTop + section.offsetHeight
                        ) {
                            navbarLinks.forEach(function (navLink) {
                                navLink.classList.remove('active');
                            });
                            link.classList.add('active');
                            // let productNavBarActiveEle = document.querySelector('.product-navbar .active-element');
                            // if (productNavBarActiveEle) {
                            //     productNavBarActiveEle.textContent = link.textContent;
                            // }
                        }
                    }
                });

                // let productNavBarEle = document.querySelector('.product-navbar .active-element');
                // if (productNavBarEle) {
                //     productNavBarEle.classList.remove('active');
                // }
                let productNavBarUl = document.querySelector('.product-navbar ul');
                if (productNavBarUl) {
                    productNavBarUl.classList.remove('show');
                }
            }

            // Scroll event handling
            window.addEventListener('scroll', onScroll);


            // let productNavBarActiveEle = document.querySelector('.product-navbar .active-element');
            // if (productNavBarActiveEle) {
            //     productNavBarActiveEle.addEventListener('click', function () {
            //         this.classList.toggle('active');
            //         this.nextElementSibling.classList.toggle('show');
            //     });
            // }

            // Get the height of the panel
            var headerHeight = 0;
            ['#shopify-section-static-announcement-bar', '#shopify-section-static-announcement-bar-alt', '#shopify-section-global-top-bar-slider', '#shopify-section-global-timer-banner', '.shopify-section-group-header-group-new '].forEach(function (selector) {
                var element = document.querySelector(selector);
                if (element) {
                    headerHeight += element.offsetHeight;
                }
            });

            // Process a click on the anchor link
            var anchorLinks = document.querySelectorAll('.product-navbar a');
            anchorLinks.forEach(function (link) {
                link.addEventListener('click', function (e) {
                    e.preventDefault();

                    // Define the target block for scrolling
                    var targetBlockId = link.getAttribute('href');
                    var targetBlockOffsetTop =
                        document.querySelector(targetBlockId).offsetTop;

                    var locationTop = targetBlockOffsetTop - headerHeight;

                    // Scroll the page to the target block with animation
                    scrollTo(locationTop < 100 ? 0 : locationTop, 100);

                    // Add anchor to URL
                    history.pushState({}, '', link.href);
                });
            });

            // Function for smooth page scrolling with animation
            function scrollTo(to, duration) {
                var start = window.pageYOffset;
                var change = to - start;
                var currentTime = 0;
                var increment = 10;

                function animateScroll() {
                    currentTime += increment;
                    var position = easeInOutLinear(currentTime, start, change, duration);
                    window.scrollTo(0, position);
                    if (currentTime < duration) {
                        requestAnimationFrame(animateScroll);
                    }
                }

                // Simple linear animation function (easeInOutLinear)
                function easeInOutLinear(t, b, c, d) {
                    t /= d;
                    return c * t + b;
                }

                requestAnimationFrame(animateScroll);
            }
        }

        setupScrollAndNavigation();
        //END - Handling .product-navbar logic
    }




    if (document.querySelectorAll('.product-section-ajax__triggers-wrapper').length) {
        //load all section
        const productPage = document.querySelector('.product-page-story');
        const shopifySections = productPage.querySelectorAll('.shopify-section');

        const sectionIds = ['#shopify-section-product-navbar'];

        shopifySections.forEach(section => {
            sectionIds.push('#' + section.id);
        });


        //click button ajax
        function handleLinkClick (link, template) {
                // document.querySelector('.product-section-ajax__btn').classList.add('disabled');
                var elements = document.querySelectorAll(".aos-animate");
                elements.forEach(function (element) {
                    element.classList.remove("aos-animate");
                });
                let api_link = link;
                if (template != '') {
                    api_link = `${api_link}?view=${template}`
                }
                fetch(api_link)
                    .then(response => response.text())
                    .then((data) => {
                        dataSections = new DOMParser().parseFromString(data, 'text/html');

                        sectionIds.forEach((arr, index) => {
                            if (index == 3) {
                                AOS.init();
                            }

                            if (!dataSections.querySelector(arr)) {
                                console.warn(`Section with selector ${arr} not found in the fetched content.`);
                                return;
                            }

                            var benefitSectionFromParsedDOM = dataSections.querySelector(arr).innerHTML;
                            var targetBenefitSection = document.querySelector(arr);
                            targetBenefitSection.innerHTML = benefitSectionFromParsedDOM;

                            // Insert the script execution after the HTML insertion
                            var scripts = targetBenefitSection.querySelectorAll('script');
                            scripts.forEach(script => {
                                try {
                                    const newScript = document.createElement("script");
                                    if (script.innerHTML.includes("DOMContentLoaded")) {
                                    newScript.innerHTML = script.innerHTML.replace("DOMContentLoaded", "load");
                                    } else {
                                    newScript.innerHTML = script.innerHTML;
                                    }
                                    if (script && script.parentNode) {
                                        script.parentNode.replaceChild(newScript, script);
                                    }
                                } catch (error) {
                                    console.error('Error executing script:', error);
                                }
                            });

                            //History push state new link
                            var newUrl = link;
                            history.pushState(null, null, newUrl);
                            //END - history push state new link
                        });
                    })
                    .then(() => {
                        document.querySelectorAll('.product-section-ajax__triggers-wrapper a').forEach((linkEl) => {
                            linkEl.addEventListener('click', function (e) {
                                e.preventDefault();

                                let link = linkEl.getAttribute('href');
                                handleLinkClick(link);
                            });
                        });

                        //re-init add cart
                        window.initCartFormHandler();

                        // re-init Yotpo
                        new Yotpo.API(yotpo).refreshWidgets();

                        //re-init animation

                        window.modalLogic();
                        setTimeout(() => {
                            // re-init Yotpo
                            yotpoWidgetsContainer.initWidgets();
                            //other re-init
                            AOS.init();
                            smoothScroll();
                            setupScrollAndNavigation();
                            window.sliderInstagram();
                        }, 500)
                    })
                    .catch(error => {
                        console.error('Fetch error:', error);
                    });
            }

        // document.body.addEventListener('click', (e) => {
        //     if(e.target.classList.contains('ajax-toggle-btn') && e.target.closest('.product-section-ajax__triggers-wrapper')) {
        //         e.preventDefault();
        //         let linkEl = e.target;
        //         let link = linkEl.getAttribute('href');
        //         handleLinkClick(link, linkEl.dataset.template);
        //     }
        // })
    }
});


//modal update button

function removeAllCheck() {
    if (document.querySelectorAll('.buy-product-modal .checked-radio').length) {
        document.querySelectorAll('.buy-product-modal .checked-radio').forEach(function (item) {
            item.classList.remove('checked-radio');
        })
    }
}


function initRechargeButton() {
    var customRechargeSelect = document.querySelector('.buy-product-modal .custom-recharge-select');
    var rechargeWidgetTypeList = document.querySelector('.buy-product-modal .recharge-widget-type-list');

    if (document.querySelectorAll('.buy-product-modal .custom-recharge-select').length) {
        customRechargeSelect.addEventListener('click', function (event) {
            var withinCustomRechargeSelect = customRechargeSelect.contains(event.target);

            if (!customRechargeSelect.classList.contains('active')) {
                customRechargeSelect.classList.add('active');

                const inputElement = document.querySelector('.buy-product-modal .recharge-widget-type-list-item.d-none input');
                inputElement.checked = true;
                const changeEvent = new Event('change', { bubbles: true });

                inputElement.dispatchEvent(changeEvent);
                removeAllCheck();
                this.classList.add('checked-radio');
                document.querySelector('.buy-product-modal .recharge-widget-type-list').classList.remove('d-none');
            } else if (withinCustomRechargeSelect && customRechargeSelect.classList.contains('active')) {
                customRechargeSelect.classList.remove('active');
                rechargeWidgetTypeList.classList.add('d-none');
            }

        });

        document.addEventListener('click', function (event) {
            var withinCustomRechargeSelect = customRechargeSelect.contains(event.target);

            if (!withinCustomRechargeSelect && customRechargeSelect.classList.contains('active')) {
                rechargeWidgetTypeList.classList.add('d-none');
                customRechargeSelect.classList.remove('active');
            }
        });

        // Get reference to DOM element

        var subscriptionOptions = document.querySelectorAll('.buy-product-modal .recharge-widget-type-list-item');
        var customRechargeSelectBox = document.querySelector('.buy-product-modal .custom-recharge-select__box');

        subscriptionOptions.forEach((option) => {
            option.addEventListener('change', function () {
                removeAllCheck();
                option.classList.add('checked-radio');


                document.querySelector('.buy-product-modal #current_plan').value = option.querySelector('input').getAttribute('data-pan-subscription-option');

                if (option.getAttribute('data-target') == 'subscription') {
                    var selectedTitle = this.querySelector('.buy-product-modal .recharge-widget__title');
                    var selectedDiscount = this.querySelector('.buy-product-modal .recharge-widget__discount');
                    var selectedText = this.querySelector('.buy-product-modal .recharge-widget__text');
                    var selectedPrice = this.querySelector('.buy-product-modal .recharge-widget__price .new-price span') || this.querySelector('.buy-product-modal .recharge-widget__price .new-price');
                    var selectedOldPrice = this.querySelector('.buy-product-modal .recharge-widget__price .old-price span') || this.querySelector('.buy-product-modal .recharge-widget__price .old-price');

                    var titleRecharge = customRechargeSelectBox.querySelector('.buy-product-modal .title-recharge');
                    var discountRecharge = customRechargeSelectBox.querySelector('.buy-product-modal .discount-recharge');
                    var descRecharge = customRechargeSelectBox.querySelector('.buy-product-modal .desc-recharge');
                    var newPriceSpan = customRechargeSelectBox.querySelector('.buy-product-modal .custom-recharge-select__box .new-price span') || customRechargeSelectBox.querySelector('.buy-product-modal .custom-recharge-select__box .new-price');
                    var oldPriceSpan = customRechargeSelectBox.querySelector('.buy-product-modal .custom-recharge-select__box .old-price');

                    if (selectedTitle) {
                        var newTitle = selectedTitle.textContent;
                        titleRecharge.textContent = newTitle;
                    }

                    if (selectedDiscount) {
                        var newDiscount = selectedDiscount.textContent;
                        discountRecharge.textContent = newDiscount;
                        discountRecharge.classList.remove('d-none');
                    } else {
                        discountRecharge.classList.add('d-none');
                    }

                    if (selectedText) {
                        var newText = selectedText.textContent;
                        descRecharge.textContent = newText;
                        descRecharge.classList.remove('d-none');
                    } else {
                        descRecharge.classList.add('d-none');
                    }

                    if (selectedPrice) {
                        var newPrice = selectedPrice.textContent;
                        newPriceSpan.textContent = newPrice;
                    }

                    if (selectedOldPrice) {
                        var oldPrice = selectedOldPrice.textContent;
                        oldPriceSpan.textContent = oldPrice;
                        oldPriceSpan.classList.remove('d-none');
                    } else {
                        oldPriceSpan.classList.add('d-none');
                    }

                    customRechargeSelect.classList.add('checked-radio');

                    window.removeActiveItemModal();
                }

            });
        });
    }
}

//modal remove dublicate button
function removeActiveItemModal() {
    var radioInputs = document.querySelectorAll('.buy-product-modal .recharge-widget-type-list input[type="radio"]');

    // Go through the found elements and process classes
    radioInputs.forEach((radioInput) => {
        var parent = radioInput.parentElement;
        if (parent) {
            if (radioInput.checked) {
                parent.classList.add('d-none');
            } else {
                parent.classList.remove('d-none');
            }
        }
    });
}

window.updateRechargButton = initRechargeButton;
window.removeActiveItemModal = removeActiveItemModal;

// Modal Bundle
function modalLogic() {
    let modalBundles = document.querySelectorAll('.section__modal-bundle');

    //Open
    let productAddToCart = document.querySelector('#product-content-area #add-to-cart-btn')
    let rechargeCheckbox = document.querySelector('#product-content-area [value="one-time"]')


    if (document.querySelectorAll('.section__modal-bundle .modal-bundle.variant-1').length) {

        productAddToCart.addEventListener('click', function (e) {
            if (!productAddToCart.classList.contains("stop")) {
                e.preventDefault();

                // If one time purchase
                if (rechargeCheckbox.checked) {
                    modalBundles.forEach(modal => {
                        if (modal.querySelector('.modal-bundle').dataset.trigger == 'bundle-trigger-otp') {
                            modal.style.display = 'table'
                        }
                    })
                } else { // If choosen option is subscribe
                    modalBundles.forEach(modal => {
                        if (modal.querySelector('.modal-bundle').dataset.trigger == 'bundle-trigger-subscribe') {
                            modal.style.display = 'table'
                        }
                    })
                }
            }
        })

        document.querySelectorAll('.modal-close').forEach((el) => {
            el.addEventListener('click', event => {
                event.preventDefault()
                productAddToCart.classList.add('stop');
                modalBundles.forEach(modal => {
                    modal.style.display = 'none'
                });

                productAddToCart.click();

                setTimeout(() => {
                    productAddToCart.classList.remove('stop')
                })
            })
        })

        document.querySelectorAll('.modal-no-thanks').forEach((el) => {
            el.addEventListener('click', event => {
                event.preventDefault()
                productAddToCart.classList.add('stop');
                modalBundles.forEach(modal => {
                    modal.style.display = 'none'
                });

                productAddToCart.click();

                setTimeout(() => {
                    productAddToCart.classList.remove('stop')
                })
            })
        })


    } else if (document.querySelectorAll('.section__modal-bundle .modal-bundle.variant-2').length) {

        productAddToCart.addEventListener('click', function () {
            // If one time purchase
            if (rechargeCheckbox.checked) {
                modalBundles.forEach(modal => {
                    if (modal.querySelector('.modal-bundle').dataset.trigger == 'bundle-trigger-otp') {
                        modal.style.display = 'table'
                    }
                })
            } else { // If choosen option is subscribe
                modalBundles.forEach(modal => {
                    if (modal.querySelector('.modal-bundle').dataset.trigger == 'bundle-trigger-subscribe') {
                        modal.style.display = 'table'
                    }
                })
            }
        })

    }
}
modalLogic()
window.modalLogic = modalLogic;


function updateRTEBasedOnCondition() {
    if (document.querySelectorAll('.progress__bar').length) {
        var allprogressBar = document.querySelectorAll('.progress__bar');
        allprogressBar.forEach(progressBar => {
            var progressMeterInfo = progressBar.querySelector('.progress-meter-info');
            // Get the current and maximum values from the progress bar attributes
        
            var currentValue = parseFloat(progressMeterInfo.getAttribute('aria-valuenow'));
            var maxValue = parseFloat(progressMeterInfo.getAttribute('aria-valuemax'));
            var textFreq = progressMeterInfo.getAttribute('aria-frequency');
            maxValue = window.ConvertCurrency(maxValue, 'USD', localStorage.getItem("iso_code"));
            // Getting texts from local storage
            var textBefore = progressMeterInfo.getAttribute('data-before');
            var textAfter = progressMeterInfo.getAttribute('data-after');
            // Calculate the percentage value
            var percentage = (currentValue / maxValue) * 100;
            var priceFormula = progressBar.querySelector('.price-formula-cart');
            if (priceFormula) {
              priceFormula.innerHTML = localStorage.getItem("symbol_currency") + maxValue.replace('.00', '');
            }

            // Get an element with the class .rte
            var rteElement =  progressBar.querySelector('.progress-label');

            var noun = maxValue - currentValue;

            if(textFreq == 'true' & currentValue < maxValue){
                rteElement.innerHTML = textAfter;
                progressBar.querySelector('.progress-meter').style.width = '100%';
            }else if (textFreq == 'false' & currentValue < maxValue) {
                // Insert text in front and update the width of the progress bar
                let amount = localStorage.getItem("symbol_currency") + noun.toFixed(2);
                rteElement.innerHTML = textBefore.replace('[amount]', amount);
            
                progressBar.querySelector('.progress-meter').style.width = percentage + '%';
            }else if (textFreq == 'false' &  currentValue > maxValue) { 
                rteElement.innerHTML = textAfter;
                progressBar.querySelector('.progress-meter').style.width = '100%';
            }else if (currentValue >= maxValue) {
                if (rteElement && textAfter) {
                    rteElement.innerHTML = textAfter;
                }
                progressBar.querySelector('.progress-meter').style.width = '100%';
            } else {
                let amount = localStorage.getItem("symbol_currency") + noun.toFixed(2);
                rteElement.innerHTML = textBefore.replace('[amount]', amount);
                progressBar.querySelector('.progress-meter').style.width = percentage + '%';
            }
        });   
    }
}

async function updateGamificationProgress() {
    if (document.querySelectorAll('.gamification').length) {
        let allGamification = document.querySelectorAll('.gamification');

        allGamification.forEach( gamification => {
            var progressBar = gamification.querySelector('.sidecart__goals--progress');
            // Get the current and maximum values from the progress bar attributes
            var currentValue = parseFloat(progressBar.getAttribute('aria-valuenow'));
            var maxValue = parseFloat(progressBar.getAttribute('aria-valuemax'));

            maxValue = window.ConvertCurrency(maxValue, 'USD', localStorage.getItem("iso_code"));

            // Calculate the percentage value
            var percentage = (currentValue / maxValue) * 100;

            // Get an element with the class .rte
            var rteElement = gamification.querySelector('.sidecart__goals-copy');

            var noun = maxValue - currentValue;
          
            if (currentValue < maxValue) {
                // Insert text in front and update the width of the progress bar
                let amount = localStorage.getItem("symbol_currency") + noun.toFixed(2);
                rteElement.innerHTML = rteElement.innerHTML;

                gamification.querySelector('.current-progress').style.width = percentage + '%';
            } else {
                // Insert text after and do not update the width of the progress bar
                rteElement.innerHTML = rteElement.innerHTML;
                gamification.querySelector('.current-progress').style.width = '100%';
            }
        });
    }
}

function updateFunctions(checkoutButton) {
    var btnAdd = document.querySelectorAll('.btn-add-to-cart');

    var sizeButtons = document.querySelectorAll('#product-options-sidecart .size-buttons');
    var selectSize = document.querySelectorAll('.gifts-block .upsell [name="variant-size"]');

    if (selectSize) {
        selectSize.forEach(function (selectSize) {
            selectSize.addEventListener('change', function (item) {
                let buttonAdd = selectSize.closest('.upsell__content').querySelector('.btn-add-to-cart');
                buttonAdd.setAttribute('data-add-to-cart-variant', selectSize.value)
            });
        });
    }

    if (sizeButtons) {
        sizeButtons.forEach(function (buttonSize) {
            buttonSize.addEventListener('change', function (item) {
                buttonSize.disabled = true;

                var radioButton = buttonSize.options[buttonSize.selectedIndex];
                let formData = { 'items': [] };
                formData.items.push({ quantity: 1, id: radioButton.dataset.variantId, properties: { 'gift_wrap': 'Free Gift' } });
                theme.cart.addProduct(formData)
                    .then(res => {
                        theme.cart.updateProduct(radioButton.dataset.currentId, 0)
                            .then(res => {
                                setTimeout(() => {
                                    buttonSize.removeAttribute('disabled');
                                    enableCheckoutButton();
                                    updateFunctions(getCheckoutButton());
                                }, 200);
                            });
                    });
            });
        });
    }

    if (btnAdd) {
        btnAdd.forEach(function (btn) {
            btn.addEventListener('click', function (event) {
                event.preventDefault();
                let itemId = btn.dataset.addToCartVariant;
                let formData = { 'items': [] };

                formData.items.push({ quantity: 1, id: itemId, properties: { 'gift_wrap': 'Free Gift' } });

                event.stopImmediatePropagation();

                theme.cart.addProduct(formData)
                    .then(data => {
                        event.stopImmediatePropagation();
                        document.dispatchEvent(new CustomEvent('cart:build'));
                    });
            });
        });
    }
}

function deleteGiftProduct(checkoutButton, cartItems, currentValue) {
    const filter1 = cartItems.filter(x => x.product_id === 8044543049974 && x.properties.gift_wrap === 'Free Gift');
    const filter2 = cartItems.filter(x => x.product_id === 7724920471798 && x.properties.gift_wrap === 'Free Gift');

    if ((currentValue < 100 && filter1.length === 0 && filter2.length === 0) ||
        (currentValue >= 100 && currentValue < 150 && filter2.length === 0) ||
        (currentValue >= 150)) {
        if (checkoutButton) {
            checkoutButton.removeAttribute('disabled');
            checkoutButton.disabled = false;
        }
    }

    if (currentValue < 150 && filter2.length === 1 && filter2[0]?.properties?.gift_wrap === 'Free Gift') {
        setTimeout(() => {
            theme.cart.updateProduct(filter2[0].id, 0).then(res => {
                document.dispatchEvent(new CustomEvent('cart:build'));
            });
        }, 150);

        return true;
    }

    if (currentValue < 100 && filter1.length === 1 && filter1[0]?.properties?.gift_wrap === 'Free Gift') {
        setTimeout(() => {
            theme.cart.updateProduct(filter1[0].id, 0).then(res => {
                document.dispatchEvent(new CustomEvent('cart:build'));
            });
        }, 150);

        return true;
    }

    if(currentValue == 0 && cartItems.length > 0 && (filter1.length > 0 || filter2.length > 0)) {
        setTimeout(() => {
            theme.cart.clearCart().then(() => {
                document.dispatchEvent(new CustomEvent('cart:build'));
            });
        }, 150);

        return true;
    }

    return false;
}

document.addEventListener('cart:build', function (event) {
    if (eventExec.value) {
        return;
    }

    eventExec.value = true;

    var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
    fetch(url, {
      credentials: 'same-origin',
      method: 'GET'
    })
    .then(response => response.json())
    .then(data => {
        let cartItems = data.items;
        let currentValue = data.total_price / 100;
        const checkoutButton = getCheckoutButton();
        const isRemovingGift = deleteGiftProduct(checkoutButton, cartItems, currentValue);

        setTimeout(() => {
            updateFunctions(checkoutButton);
            if (!isRemovingGift && data.item_count > 0) {
                enableCheckoutButton();
            }
            eventExec.value = false;
        }, 200);
    })
    .catch(() => {
        eventExec.value = false;
        enableCheckoutButton();
    });
});

document.addEventListener('cart:updated', function (event) {
    let cartItems = event.detail.cart.items;
    let currentValue = event.detail.cart.total_price / 100;
    const checkoutButton = getCheckoutButton();

    deleteGiftProduct(checkoutButton, cartItems, currentValue);

    setTimeout(() => {
        updateFunctions(getCheckoutButton());
    }, 200);

    enableCheckoutButton();
});

document.dispatchEvent(new CustomEvent('cart:build'));

window.updateRTEBasedOnCondition = updateRTEBasedOnCondition;

window.updateGamificationProgress = updateGamificationProgress;